import { Guest } from "@/types/guest";
import { Room } from "@/types/room";
import { Request } from "@/types/request";
import { CheckinStatus, CheckoutStatus } from "@/types/reservation";

export enum PreCheckStatus {
  DONE = "DONE",
  SENT = "SENT",
  SENT_3 = "SENT_3",
  SENT_7 = "SENT_7",
  NOT_DONE = "NOT_DONE",
  NOT_SEND = "NOT_SEND",
}

export interface Transaction {
  id: string;
  hotelId: string;
  tenantId: string;
  paymentSettingsId: string;
  stripePaymentIntentId: string;
  stripeChargeId: string | null;
  stripeTransferId: string | null;
  stripeRefundId: string | null;
  type: string;
  status: string;
  amount: number;
  currency: string;
  applicationFeeAmount: number | null;
  netAmount: number | null;
  bookingId: string | null;
  metadata: Record<string, any> | null;
  failureCode: string | null;
  failureMessage: string | null;
  createdAt: Date;
  completedAt: Date | null;
  refundedAt: Date | null;
}

export interface SettlementBooking {
  id: string;
  guest: Guest;
  room?: Room;
  status?: string;
  arrivalDate: Date;
  departureDate: Date;
  preCheckinReadAt?: Date;
  checkinStatus: CheckinStatus;
  checkoutStatus: CheckoutStatus;
  preCheckinStatus: PreCheckStatus;
  preCheckoutStatus: PreCheckStatus;
  serviceRequests: Request[];
  transactions: Transaction[];

  adults: number;
  children: number;
  notes: string[];
  notesCount: number;
  reviewsCount: number;
  roomServiceDone: boolean;
  roomServiceStatus?: Request["tasks"][number]["status"] | string | null;
}
